import { i18n } from "#ce/components/SpFinder/i18n";

/** Reads `frontend.finder.results.<key>`. */
export function resultText(key, values) {
  return i18n.global.t(`results.${key}`, values ?? {});
}
